import {
  SET_GROWTH_FORECAST_STAGE_DCF,
} from "./mutations";
import {store} from "../../index";
import GrowthForecastStageDCF from "../../../models/valuation/GrowthForecastStageDCF";
import {generateForecastFreeCashFlow} from "../forecastFCF/actions";

export const generateGrowthForecastStageDCF = (options = { clearCache: false }) => (dispatch) => {
  dispatch(generateForecastFreeCashFlow())

  const {
    growthForecastStageDCF,
    forecastFCF
  } = store.getState()

  const { forecastFreeCashFlow } = forecastFCF

  const relatedValues = {
    depreciation: forecastFreeCashFlow.forecastedFreeCashFlowAfterTax.depreciation,
    growthWorkingCapital: forecastFreeCashFlow.forecastedFreeCashFlowBeforeTax.growthWorkingCapital,
    capitalExpenditures: forecastFreeCashFlow.forecastedFreeCashFlowBeforeTax.capitalExpenditures,
    netOperatingProfitAfterTax: forecastFreeCashFlow.forecastedFreeCashFlowAfterTax.nopat,
    preTaxCashFlow: forecastFreeCashFlow.forecastedFreeCashFlowBeforeTax.preTaxFreeCashFlow
  }

  if (growthForecastStageDCF.growthForecastStageDCF && !options.clearCache) {
    dispatch({
      type: SET_GROWTH_FORECAST_STAGE_DCF,
      payload: new GrowthForecastStageDCF({
        ...growthForecastStageDCF.growthForecastStageDCF,
        ...relatedValues
      })
    })

    return
  }

  dispatch({
    type: SET_GROWTH_FORECAST_STAGE_DCF,
    payload: new GrowthForecastStageDCF({
      ...relatedValues
    })
  })
};

export const updateGrowthForecastStageDCF = ({
  returnOnEquity,
  returnOnAssets,
  analystChosenTwoStepGrowthRate,
  sustainableNote,
  internalNote
}) => (dispatch) => {
  const growthForecastStageDCF = {...store.getState().growthForecastStageDCF.growthForecastStageDCF}

  if (returnOnEquity || returnOnEquity === 0 || returnOnEquity === "") {
    growthForecastStageDCF.returnOnEquity = returnOnEquity
  }

  if (returnOnAssets || returnOnAssets === 0 || returnOnAssets === "") {
    growthForecastStageDCF.returnOnAssets = returnOnAssets
  }

  if (analystChosenTwoStepGrowthRate || analystChosenTwoStepGrowthRate === 0 || analystChosenTwoStepGrowthRate === "") {
    growthForecastStageDCF.analystChosenTwoStepGrowthRate = analystChosenTwoStepGrowthRate
  }

  if (sustainableNote || sustainableNote === "") {
    growthForecastStageDCF.sustainableNote = sustainableNote
  }

  if (internalNote || internalNote === "") {
    growthForecastStageDCF.internalNote = internalNote
  }

  dispatch({
    type: SET_GROWTH_FORECAST_STAGE_DCF,
    payload: new GrowthForecastStageDCF({
      ...growthForecastStageDCF
    })
  })
}